import { render, staticRenderFns } from "./MyExchangeDialog.vue?vue&type=template&id=2371fa6c&scoped=true&"
import script from "./MyExchangeDialog.vue?vue&type=script&lang=ts&"
export * from "./MyExchangeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MyExchangeDialog.vue?vue&type=style&index=0&id=2371fa6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371fa6c",
  null
  
)

export default component.exports